import React from 'react';
import styled from 'styled-components';
import { ProgressBar } from 'Components/common';

const getColor = (ratio) => {
  if (ratio >= 1.0) return 'var(--vo-danger)';
  if (ratio >= 0.8) return 'var(--vo-warning)';
  return 'var(--vo-success)';
};

const Container = styled.div`
  min-width: 80px;
`;

const Label = styled.span`
  display: block;
  font-size: 0.75rem;
  color: var(--vo-slate);
`;

const ValueText = styled.span`
  font-size: 0.75rem;
  color: ${({ $color }) => $color};
`;

const NumericOnly = styled.span`
  font-size: 0.875rem;
`;

export const UsageBar = ({ current = 0, limit, label }) => {
  if (limit == null || limit === 0) {
    return (
      <Container>
        {label && <Label>{label}</Label>}
        <NumericOnly>{current}</NumericOnly>
      </Container>
    );
  }

  const ratio = current / limit;
  const color = getColor(ratio);
  const percent = Math.min(ratio * 100, 100);

  return (
    <Container>
      {label && <Label>{label}</Label>}
      <ProgressBar
        value={percent}
        height={8}
        borderRadius={4}
        color={color}
        bgColor={'var(--vo-cloud)'}
      />
      <ValueText $color={color}>{current} / {limit}</ValueText>
    </Container>
  );
};
